export const TITLE = 'Mini'
